/** Funnel mock payloads until B3 /funnel ships. */

import { FUNNEL_MOCK_ATTENDANCE } from './funnelMock_attendance';
import { FUNNEL_MOCK_MEMBERSHIP } from './funnelMock_membership';
import { FUNNEL_MOCK_SALES_CHANNEL } from './funnelMock_sales_channel';

export const FUNNEL_MOCK_BY_MODE = {
  attendance: FUNNEL_MOCK_ATTENDANCE,
  membership: FUNNEL_MOCK_MEMBERSHIP,
  sales_channel: FUNNEL_MOCK_SALES_CHANNEL,
};
